module.exports = require("@swa-ui/dotcom/src/placements/RotatingBannerPlacement/RotatingBannerPlacement.module.scss");